module.exports = __webpack_public_path__ + "static/media/checklist.820ae948.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/icons/checklist.svg
 ** module id = 607
 ** module chunks = 44
 **/